export { default as isDomAvailable } from "./isDomAvailable"
export { default as priceCalculator } from "./priceCalculator"
export { default as getItemType } from "./getItemType"
export { default as debounce } from "./debounce"
export const round = (number, decimalPoints = 2) =>
    Number(Number.parseFloat(number).toFixed(decimalPoints))
